import React from "react";
import { AttributeNameValue } from "@src/components/atoms/attribute-name-value/attribute-name-value";
import styles from "./operation-protocol-details.module.scss";

interface OperationProtocolDetailsProps {
  className: string;
  protocolEntries: Array<[string, string]>;
  opcUaErrorDescriptions: string[];
  opcUaErrorDetailsTitle: string;
}

export const OperationProtocolDetails = ({
  className,
  protocolEntries,
  opcUaErrorDescriptions,
  opcUaErrorDetailsTitle,
}: OperationProtocolDetailsProps) => {
  const opcUaDetails = opcUaErrorDescriptions.length > 0 && (
    <>
      <p className={styles["operation-protocol-details__error-title"]}>
        {opcUaErrorDetailsTitle}
      </p>
      <ul className={styles["operation-protocol-details__error-list"]}>
        {opcUaErrorDescriptions.map((description, index) => (
          <li key={`${description}-${index}`}>{description}</li>
        ))}
      </ul>
    </>
  );

  return (
    <div className={className}>
      {protocolEntries.map(([key, value]) => (
        <React.Fragment key={key}>
          <AttributeNameValue name={`${key}:`} value={String(value)} />
          {key === "Detail" && opcUaDetails}
        </React.Fragment>
      ))}
      {!protocolEntries.some(([key]) => key === "Detail") && opcUaDetails}
    </div>
  );
};
